export function logError(error, customAttributes) {

}


// WEBPACK FOOTER //
// ./src/js/logError.js